import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './AuthPages.module.css';

/** Společný rámec přihlašovacích obrazovek (login / registrace / obnova hesla). */
export function AuthLayout({ subtitle, children }: { subtitle: string; children: ReactNode }) {
  return (
    <div className={styles.screen}>
      <Link to="/" className={styles.backLink}>
        <span aria-hidden>←</span> Úvodní stránka
      </Link>
      <div className={styles.card}>
        <div className={styles.brand}>
          <Link to="/" className={styles.logo} aria-label="Zpět na úvodní stránku">
            S
          </Link>
          <div className={styles.title}>SiteDoc</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>

        {children}

        <div className={styles.footer}>
          <Link to="/ochrana-osobnich-udaju">Ochrana osobních údajů</Link> · app.sitedoc.cz · v2
        </div>
      </div>
    </div>
  );
}
